import * as Yup from 'yup';

export const addCompanySchema = Yup.object().shape({
    name: Yup.string()
        .required('Company name is required')
        .matches(/^[A-Za-z\s]+$/, 'Company name should only contain alphabets and spaces')
        .min(2, 'Company name must be at least 2 characters'),

    pocName: Yup.string()
        .required('POC name is required')
        .matches(/^[A-Za-z\s]+$/, 'POC name should only contain alphabets and spaces')
        .min(2, 'POC name must be at least 2 characters'),

    pocContact: Yup.string()
        .required('POC contact is required')
        .matches(/^\d{11}$/, 'Contact number must be exactly 11 digits')
        .matches(/^03[0-9]{9}$/, 'Contact number must start with 03'),

    // email: Yup.string()
    //     .required('Email is required')
    //     .matches(
    //         /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //         'Invalid email format. Example: email.123@test.com'
    //     )
    email: Yup.string().email('Invalid email').required('Email required'),
});

export const loginSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email required'),
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[\W_]/, 'Password must contain at least one special character')
});

export const addAssigneeSchema = Yup.object().shape({
    tender_lead: Yup.string().required('Tender lead is required'),
    // assignments: Yup.array().of(
    //     Yup.object().shape({
    //         type: Yup.string().required('Type is required'),
    //         assignees: Yup.array(),
    //         deadline: Yup.date()
    //     })
    // ).test('at-least-one-assignment', 'At least one complete assignment is required', function(assignments) {
    //     return assignments.some(assignment =>
    //         assignment.assignees?.length > 0 && assignment.deadline
    //     );
    // })
});

export const profileSchema = Yup.object().shape({
    full_name: Yup.string()
        .required('Full name is required')
        .max(20, 'Name should not exceed 20 characters')
        .matches(/^[A-Za-z\s]+$/, 'Full name must only contain alphabets and spaces'),
    email: Yup.string().email('Invalid email').required('Email required'),
    image: Yup.mixed()
});

export const changePasswordSchema = Yup.object().shape({
    current_password: Yup.string()
        .required('Current password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[\W_]/, 'Password must contain at least one special character'),
    new_password: Yup.string()
        .required('New password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[\W_]/, 'Password must contain at least one special character')
        .notOneOf([Yup.ref('current_password')], 'New password must be different from current password'),
    confirm_password: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref('new_password')], 'Passwords must match')
});

export const signUpSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email required'),
    user_name: Yup.string()
        .required('Full name is required')
        .matches(/^[A-Za-z\s]+$/, 'Name must only contain alphabets and spaces'),
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[\W_]/, 'Password must contain at least one special character'),
    confirm_password: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref('password')], 'Passwords must match'),
    department_id: Yup.string()
        .required('Department is required')
});

export const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email required'),
});

export const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .matches(/[\W_]/, 'Password must contain at least one special character'),
    confirm_password: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref('password')], 'Passwords must match')
});